import type { DataAccessAssignment } from '../types'

/**
 * Returns the indicative count of employees affected by a rule.
 * Departments are not resolved client-side — if departments are present,
 * callers should show an impactHelper note.
 */
export const computeImpactCount = (rule: DataAccessAssignment): number => {
    const direct = rule.assignees?.length ?? 0
    const teammates = rule.teammates?.length ?? 0
    return direct + teammates
}
